<template>
  <div>
    <div v-if="addNew" >
      <div class="flex">
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
            First Name
          </label>
          <input v-model.trim="newExhibitor.first_name" class="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" placeholder="Jane">
        </div>
        <div class="w-full md:w-1/2 px-3">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
            Last Name
          </label>
          <input v-model.trim="newExhibitor.last_name" class="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="text" placeholder="Doe">
        </div>
      </div>
      <div class="flex justify-end items-center">
        <button @click="addNew=false" class="btn-red-outline btn-sm mr-2">Cancel</button>
        <button @click="saveExhibitor" class="btn btn-blue">Save</button>
      </div>
    </div>
    <div v-else>
      <multiselect @input="exhibitorSelected" v-model="exhibitor" :options="exhibitorList" :close-on-select="true" :searchable="false" placeholder="Select an Exhibitor" label="name" track-by="first_name" :custom-label="(option) => {return `${option.first_name} ${option.last_name}`}"></multiselect>
      <p class="text-base text-gray-900 pt-2">Don't see the exhibitor on the list? <span class="font-bold link cursor-pointer" @click="addNew=true">Click here to add a new exhibitor</span></p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initExhibitor: Object,
    isAdmin: {
      type: Boolean,
      default: false
    },
    user_id: String
  },
  data () {
    return {
      exhibitor: null,
      addNew: false,
      newExhibitor: {
        exhibitor_details: {}
      }
    }
  },
  methods: {
    saveExhibitor () {
      this.exhibitor = this.newExhibitor
      this.addNew = false
      this.exhibitor.name = 'exhibitors'
      this.exhibitor.user_id = this.user_id
      this.$store.dispatch('addUserData', this.exhibitor)
        .then(response => {
          this.exhibitor.exhibitor_id = response.data.data.exhibitor_id
          this.exhibitorSelected()
          if (this.isAdmin) {
            this.$store.dispatch('addExhibitorToAdminData', this.exhibitor)
          }
          this.notie.alert({
            type: 1,
            text: `Exhibitor Added`
          })
          this.newExhibitor = {
            exhibitor_details: {}
          }
        })
        .catch(error => {
          this.exhibitor = null
          this.notie.alert({
            type: 3,
            time: 6,
            text: `Error creating Exhibitor:<br>${error.response.data.error_message}<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
          // this.$honeybadger.notify(error)
        })
    },
    exhibitorSelected () {
      this.$emit('input', this.exhibitor)
    },
    clearExhibitor () {
      this.exhibitor = null
      this.newExhibitor = {
        exhibitor_details: {}
      }
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.user
    },
    adminData () {
      return this.$store.state.admin.adminData
    },
    exhibitors () {
      if (this.currentUser) {
        return this.$store.state.userData.exhibitors
      } else {
        return []
      }
    },
    defaultExhibitor () {
      if (this.currentUser) {
        return {
          first_name: this.currentUser.first_name,
          last_name: this.currentUser.last_name,
          exhibitor_details: {}
        }
      } else {
        return {}
      }
    },
    exhibitorList () {
      if (!this.isAdmin) {
        let list = JSON.parse(JSON.stringify(this.exhibitors))
        if (!this.exhibitors.find(e => {
          return e.first_name === this.defaultExhibitor.first_name && e.last_name === this.defaultExhibitor.last_name
        })) {
          list.push(this.defaultExhibitor)
        }

        return list
      } else {
        let list = this.adminData.exhibitors.filter(e => {
          return e.user_id === this.user_id
        })
        if (this.newExhibitor.first_name && this.newExhibitor.last_name) {
          list.push(this.newExhibitor)
        }
        return list
      }
    }
  },
  created () {
    this.exhibitor = this.initExhibitor
  }
}
</script>

<style>

</style>
